import { createReportDataWithDynamicMetricsRequest } from "./createReportDataRequest";
import { KnownDimensionCodes } from "./metrics";

export const getOverallFunnelPerformanceDataRequest = createReportDataWithDynamicMetricsRequest([]);

export const getDateDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.date]);

export const getEnvironmentDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.environment]);

export const getWeekdayDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.weekday]);

export const getAgeGroupDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.agegroup]);

export const getGenderDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.gender]);

export const getOSDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.os]);

export const getRegionDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.region]);

export const getAdFormatsDataRequest = createReportDataWithDynamicMetricsRequest([KnownDimensionCodes.adFormat]);

export const getAdFormatAdTemplateDataRequest = createReportDataWithDynamicMetricsRequest([
    KnownDimensionCodes.adFormat,
    KnownDimensionCodes.adTemplate
]);

export const getAdInteractionDataRequest = createReportDataWithDynamicMetricsRequest([
    KnownDimensionCodes.adFormat,
    KnownDimensionCodes.adTemplate
]);
